import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const renderText = (text) => {
  const parts = text.split(/(\[\[[^\]]+\]\])/g);
  return parts.map((part, i) => {
    const m = part.match(/^\[\[([^|]+)\|([^\]]+)\]\]$/);
    if (!m) return part;
    return (
      <Link key={i} to={m[2]} className="font-medium text-brand underline-offset-2 transition-colors hover:text-brand-dark hover:underline">
        {m[1]}
      </Link>
    );
  });
};

export const BodySections = ({ sections }) => (
  <section data-testid="body-sections" className="section bg-white">
    <div className="container-site">
      <div className="max-w-[760px] space-y-14">
        {sections.map((s, i) => (
          <Reveal as="article" key={s.heading} data-testid={`body-section-${i + 1}`}>
            <h2>{s.heading}</h2>
            <div className="mt-5 space-y-5 text-base text-body">
              {s.paragraphs.map((p, j) => (
                <p key={j}>{renderText(p)}</p>
              ))}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
